// extracted by mini-css-extract-plugin
export default {"player":"player__ugjkr"};